import { EntidadBancariaDtoProps } from "api/DTOs/EntidadBancariaDto"
import { getEntidadBancariaByIban } from "api/EntidadBancaria.services"
import { InputText } from "primereact/inputtext"
import {
  Control,
  Controller,
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form"
import { useTranslation } from "react-i18next"
import { DropdownEntidadesBancarias } from "../../../DropdownEntidadesBancarias/DropdownEntidadesBancarias"
import { CuentaBancariaFormValues } from "../../UseCuentaBancariasForm"

interface BankSelectorProps {
  register: UseFormRegister<CuentaBancariaFormValues>
  setValue: UseFormSetValue<CuentaBancariaFormValues>
  control: Control<CuentaBancariaFormValues>
  watch: UseFormWatch<CuentaBancariaFormValues>
  errors?: FieldErrors<CuentaBancariaFormValues>
  clearErrors: UseFormClearErrors<CuentaBancariaFormValues>
}
export const BankSelector = ({
  register,
  setValue,
  control,
  watch,
  clearErrors,
  errors,
}: BankSelectorProps) => {
  const { t } = useTranslation()
  const handleIbanChange = async (iban: string) => {
    setValue("iban", iban)
    if (iban.length > 14) {
      const entidadBancaria = await getEntidadBancariaByIban(iban)
      setValue("entidadBancariaId", entidadBancaria.id)
      setValue("bic", entidadBancaria.bic)
      setValue("prefilter", entidadBancaria)
    }
    clearErrors()
  }

  const handleSelectBanco = (value: EntidadBancariaDtoProps) => {
    setValue("entidadBancariaId", value.id)
    setValue("bic", value.bic)
    clearErrors()
  }

  return (
    <section className='tw-flex tw-flex-col tw-gap-4'>
      <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
        <span className='tw-text-sm'>
          {t("contactos.cuentasBancarias.iban")}
        </span>
        <InputText
          {...register("iban", { required: true })}
          onChange={(ev) => handleIbanChange(ev.target.value)}
          placeholder={`${t("contactos.cuentasBancarias.ibanPlaceholder")}`}
          className={`tw-w-full tw-text-sm tw-h-10 ${
            errors?.iban ? "!tw-border-danger" : ""
          }`}
        />
      </div>
      <div className='tw-w-full tw-grid tw-grid-cols-2 tw-gap-4'>
        <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
          <span className='tw-text-sm'>
            {t("contactos.cuentasBancarias.bank")}
          </span>
          <span>
            <Controller
              control={control}
              name='entidadBancariaId'
              rules={{ required: true }}
              render={({ field }) => (
                <DropdownEntidadesBancarias
                  value={field.value}
                  onChange={handleSelectBanco}
                  prefilter={watch("prefilter")}
                  className={
                    errors?.entidadBancariaId ? "!tw-border-danger" : ""
                  }
                />
              )}
            />
          </span>
        </div>
        <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
          <span className='tw-text-sm'>
            {t("contactos.cuentasBancarias.swiftBic")}
          </span>
          <span>
            <InputText
              disabled={!watch("canEditBic")}
              className={`tw-w-full tw-text-sm tw-h-10 ${
                errors?.bic ? "!tw-border-danger" : ""
              }`}
              {...register("bic", { required: true })}
              placeholder='BIC/SWIFT'
            />
          </span>
        </div>
      </div>
    </section>
  )
}
